import { CustomAction } from 'model/state';
import {
  FETCH_CONSUMPTION_BY_LOCATION, FETCH_CONSUMPTION_BY_LOCATION_SUCCESS, FETCH_CONSUMPTION_BY_LOCATION_ERROR,
  CLEAN_CONSUMPTION_DATA, FETCH_AREA_TEMPERATURE_BY_LOCATION, FETCH_AREA_TEMPERATURE_BY_LOCATION_SUCCESS,
  FETCH_AREA_TEMPERATURE_BY_LOCATION_ERROR, UPDATE_CONSUMPTION_FILTER, FETCH_CONSUMPTION_BY_FILTERS,
  FETCH_CONSUMPTION_BY_FILTERS_SUCCESS, FETCH_CONSUMPTION_BY_FILTERS_ERROR
} from 'constants/ActionTypes';
import { ConsumptionPeriod, Location, ConsumptionData, ConsumptionFilter, IntervalType } from 'model';

/**
 * Payload
 */
export interface ConsumptionPayload {
  period?: ConsumptionPeriod;
  location?: Location;
  consumptionData?: ConsumptionData;
  areaTemperature?: number;
  timezone?: string;
  macAddress?: string;
  filters?: ConsumptionFilter;
  partialFilters?: Partial<ConsumptionFilter>;
  intervalType?: IntervalType;
  locationIds?: string[];
  userId?: string;
}

/**
 * Actions
 */
export const fetchConsumptionData = (period: ConsumptionPeriod, location: Location): CustomAction<ConsumptionPayload> => {
  return {
    type: FETCH_CONSUMPTION_BY_LOCATION,
    payload: { period, location }
  };
};

export const fetchConsumptionDataSuccess = (consumptionData: ConsumptionData, intervalType: IntervalType): CustomAction<ConsumptionPayload> => {
  return {
    type: FETCH_CONSUMPTION_BY_LOCATION_SUCCESS,
    payload: { consumptionData, intervalType }
  };
};

export const fetchConsumptionDataError = (): CustomAction<ConsumptionPayload> => {
  return {
    type: FETCH_CONSUMPTION_BY_LOCATION_ERROR,
  };
};

export const cleanConsumptionData = (): CustomAction<ConsumptionPayload> => {
  return {
    type: CLEAN_CONSUMPTION_DATA,
  };
};

export const fetchAreaTemperatureByLocation = (macAddress: string, timezone: string): CustomAction<ConsumptionPayload> => {
  return {
    type: FETCH_AREA_TEMPERATURE_BY_LOCATION,
    payload: { macAddress, timezone }
  };
};

export const fetchAreaTemperatureByLocationSuccess = (areaTemperature: number): CustomAction<ConsumptionPayload> => {
  return {
    type: FETCH_AREA_TEMPERATURE_BY_LOCATION_SUCCESS,
    payload: { areaTemperature }
  };
};

export const fetchAreaTemperatureByLocationError = (): CustomAction<ConsumptionPayload> => {
  return {
    type: FETCH_AREA_TEMPERATURE_BY_LOCATION_ERROR,
  };
};

export const updateConsumptionFilters = (filters: Partial<ConsumptionFilter>): CustomAction<ConsumptionPayload> => {
  return {
    type: UPDATE_CONSUMPTION_FILTER,
    payload: { partialFilters: filters }
  };
};

export const fetchConsumptionByFilters = (filters: ConsumptionFilter, timezone: string, userId?: string): CustomAction<ConsumptionPayload> => {
  return {
    type: FETCH_CONSUMPTION_BY_FILTERS,
    payload: { filters, timezone, userId }
  };
};

export const fetchConsumptionByFiltersSuccess = (consumptionData: ConsumptionData, intervalType: IntervalType): CustomAction<ConsumptionPayload> => {
  return {
    type: FETCH_CONSUMPTION_BY_FILTERS_SUCCESS,
    payload: { consumptionData, intervalType }
  };
};

export const fetchConsumptionByFiltersError = (): CustomAction<ConsumptionPayload> => {
  return {
    type: FETCH_CONSUMPTION_BY_FILTERS_ERROR,
  };
};